const alignmentOpts = ["left", "right", "center"];
const isAlignment = (alignment) => alignmentOpts.includes(alignment);
const isElement = (domNode) => "attribs" in domNode;
const isDomNode = (child) => child?.type !== "cdata" && child?.type !== "root";
const isChildNodeElement = (child) => isDomNode(child) && isElement(child);
export {
  isAlignment,
  isChildNodeElement,
  isDomNode,
  isElement
};
//# sourceMappingURL=typeguards.js.map
